import React, { useEffect, useState } from "react";
import Select from "react-select";

function CustomDropDownReward({
  name,
  register,
  labelTitle,
  placeholder,
  icon,
  setValue,
  showError,
  errorMessage,
  options,
  showMandatory = false,
  defaultOption,
  parentProps,
  onChange,
  resetValue,
  setResetValue,
  additionalclass,
  indicatorColor = '#F6821F',
  ...props
}) {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  useEffect(() => {
    setSelectedOption(defaultOption);
  }, [defaultOption]);

  useEffect(() => {
    if (resetValue) {
      setResetValue(false);
      setSelectedOption(null);
    }
  }, [resetValue]);

  return (
    <div className="form-group d-flex flex-column w-100" {...parentProps}>
      <h3 className="fw-600 medium-text mb-0">
        {labelTitle}{showMandatory ? <span className="danger">*</span> : null}
      </h3>

      <div className={`d-flex flex-column reward-dropdown-mobile px-3 ${additionalclass}`}>
        <div className="d-flex gap-2 mt-1">
          <Select
            className="rewarddropdowntext w-100 border-0"
            defaultValue={selectedOption}
            maxMenuHeight={200}
            onChange={(e) => {
              if (setValue) setValue(name, e.value, { shouldValidate: true });
              setSelectedOption(e);
              if (onChange) onChange(e);
            }}
            value={selectedOption}
            {...props}

            placeholder={placeholder}
            noOptionsMessage={() => "No Data Available!"}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: 0,
                boxShadow: "none",
                borderColor: '#e2e2e2',
                background: "transparent"
              }),
              container: (baseStyles, state) => ({
                ...baseStyles
              }),
              valueContainer: (baseStyles, state) => ({
                ...baseStyles,
                padding: '0px',
                height: 43,
                borderWidth: 0,
                border: 0,
                boxShadow: "none",
                fontSize: "14px",
                fontWeight: "400",

              }),
              singleValue: (baseStyles, state) => ({
                ...baseStyles,
                color: selectedOption ? '#F6821F' : 'black',
                fontWeight: 600,
                fontSize: 16,
              }),
              indicatorSeparator: (baseStyles, state) => ({
                ...baseStyles,
                display: "none"

              }),
              dropdownIndicator: (baseStyles, state) => ({
                ...baseStyles,
                color: selectedOption ? indicatorColor : 'black',
              }),
              menu: (baseStyles, state) => ({
                ...baseStyles,
                zIndex: 999,
                clipPath: "padding-box",
                borderRadius: 6,
                boxShadow: "0px 0px 10px #0000001A",
                border: 0
              }),
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                padding: 0,
                border: "0"

              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                padding: "12px 16px",
                fontWeight: 600,
                fontSize: 16,
                borderBottom: "0",

              }),
            }}
            theme={(theme) => ({
              ...theme,
              borderRadius: 8,
              colors: {
                ...theme.colors,
                primary: '#F6821F',
                primary25: '#fffff',
                primary50: "#F6821F1A"
              },
            })}
            options={options}
          />
        </div>
      </div>

      {showError ? <span className="danger small-text fw-400 mt-2">{errorMessage}</span> : null}
    </div>
  );
}

export default CustomDropDownReward;
